/* =========================================================
	JS
========================================================= */

/* MARK: Cookie Consent
----------------------------------------------- */
import CookieConsentInit from './includes/cookieconsent-config';
new CookieConsentInit();

import './includes/search';

import UIkit from 'uikit';
import MicroModal from "micromodal";

/* MARK: Mobile nav
----------------------------------------------- */
import './includes/slideToggle';
document.querySelector('.min-links').addEventListener('click', function(e) {
	if (e.target.classList.contains('tab')) {
		var nextPanel = e.target.nextElementSibling;
		nextPanel.slideToggle(200);
		// to make other panels collapse when you open one:
		document.querySelectorAll('.min-links .panel').forEach(function(el) {
			if (el.style.display !== "none" && el !== nextPanel) { el.slideUp(200); }
		});
	}
});

/* MARK: Modals
----------------------------------------------- */
MicroModal.init({
	disableScroll: true,
   openClass: 'is-open',
});
